"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var containerTypes_exports = {};
__export(containerTypes_exports, {
  hostAlignments: () => hostAlignments,
  hostAxes: () => hostAxes,
  zStackAlignments: () => zStackAlignments
});
module.exports = __toCommonJS(containerTypes_exports);
var hostAxes = [
  "vertical",
  "horizontal"
];
var hostAlignments = [
  "leading",
  "center",
  "trailing"
];
var zStackAlignments = [
  "topLeading",
  "top",
  "topTrailing",
  "leading",
  "center",
  "trailing",
  "bottomLeading",
  "bottom",
  "bottomTrailing"
];
//# sourceMappingURL=containerTypes.js.map
